<template>
  <div class="imageDisplaySelect">
    <div
      class="imageDisplaySelect_controller"
      :class="{ ['imageDisplaySelect_controller--open']: open }"
    >
      <div class="imageDisplaySelect_controller-container">
        <v-btn
          class="imageDisplaySelect_filter-btn"
          depressed
          x-small
          color="primary"
          text
          @click="open = !open"
        >
          <div class="imageDisplaySelect_text">カメラ映像</div>
          <span
            class="icon icon-chevron-down"
            :class="{ 'imageDisplaySelect_chevron-open': open }"
          />
        </v-btn>
      </div>
    </div>
    <div v-if="open">
      <div class="imageDisplaySelect_cams">
        <template v-for="(option, index) in options">
          <v-btn
            :key="index"
            class="imageDisplaySelect_btn"
            depressed
            x-small
            :color="selectedOption === index ? 'primary' : ''"
            :outlined="selectedOption !== index"
            @click="selectOption(index)"
          >
            {{ option }}
          </v-btn>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageDisplaySelect',
  props: {
    defaultSelect: {
      type: Number,
      default: 1,
    },
    selectedClips: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    open: false,
    selectedOption: 0,
    options: ['カメラ映像 非表示', 'カメラ映像 表示'],
  }),
  watch: {
    open() {
      this.$emit('onOpen', this.open);
    },
  },
  created() {
    this.selectedOption = this.defaultSelect;
  },
  methods: {
    selectOption(index) {
      this.selectedOption = index;
      this.$emit('onSelect', index);
    },
  },
};
</script>

<style lang="scss">
.imageDisplaySelect {
  &_chevron {
    &-open {
      transform: rotate(180deg);
    }
  }

  &_controller {
    &--open {
      margin-bottom: 15px;
    }
    display: flex;
    align-items: center;
    &-info {
      flex: 1;
      justify-content: space-between;
      font-size: 14px;
      font-weight: normal;
      line-height: 0.93;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
      :first-child {
        margin-right: 10px;
      }
    }
    &-container {
      display: flex;
      justify-content: space-between;
    }
  }
  &_btn {
    margin-right: 5px;
  }
  &_cams {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 12px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &_filter-btn {
    &.v-btn {
      margin-top: 10px;
      &:not(.v-btn--round).v-size--x-small {
        padding-left: 8px;
        padding-right: 8px;
        font-size: 12px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.08;
        letter-spacing: normal;
        text-align: right;
        color: #fff;
        &.v-btn--outlined {
          padding-left: 7px;
          padding-right: 7px;
          color: #989898;
          border-color: #989898;
        }
      }
      &:not(:last-child) {
        margin-right: 8px;
      }
    }
  }
}
</style>
